import React from 'react';

import { Box } from '@components/Restyle';
import { Skeleton } from '@components/shared/Skeleton';
import theme from '@themes/theme';

/**
 * Project list row placeholder — mirrors the condensed `ProjectCard` row:
 * icon block, name, owner (avatar + name), team (icon + name), member
 * avatars. Mirrors `ComposedProjectListRow` in
 * `stories/atoms/Skeleton.stories.tsx`.
 */
export const ProjectListRowSkeleton: React.FC<{ testID?: string }> = ({
  testID = 'project-list-row-skeleton',
}) => {
  return (
    <Box
      testID={testID}
      flexDirection='row'
      alignItems='center'
      paddingVertical='s'
      borderBottomWidth={1}
      borderBottomColor='grey02'>
      <Skeleton
        variant='rect'
        width={32}
        height={32}
        borderRadius='xxs'
        style={{ marginRight: theme.spacing.s }}
      />
      <Box flex={2} style={{ marginRight: theme.spacing.m }}>
        <Skeleton variant='text' width='60%' />
      </Box>
      <Box
        flex={1}
        flexDirection='row'
        alignItems='center'
        style={{ marginRight: theme.spacing.m }}>
        <Skeleton
          variant='circle'
          width={24}
          height={24}
          style={{ marginRight: theme.spacing.xs }}
        />
        <Box flex={1} style={{ gap: theme.spacing.xxxs }}>
          <Skeleton variant='text' width='70%' />
          <Skeleton variant='text' width='35%' />
        </Box>
      </Box>
      <Box
        flex={1}
        flexDirection='row'
        alignItems='center'
        style={{ marginRight: theme.spacing.m }}>
        <Skeleton
          variant='rect'
          width={24}
          height={24}
          borderRadius='xxs'
          style={{ marginRight: theme.spacing.xs }}
        />
        <Skeleton variant='text' width='60%' />
      </Box>
      <Box flexDirection='row' style={{ gap: theme.spacing.xxxs }}>
        <Skeleton variant='circle' width={24} height={24} />
        <Skeleton variant='circle' width={24} height={24} />
      </Box>
    </Box>
  );
};
